
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { tap } from 'rxjs/operators'
import { OktaAuthService } from '@okta/okta-angular';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {

  constructor(private oktaAuth: OktaAuthService, private router: Router) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.handleAccess(request, next));
  }

  private handleAccess(request: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {
    // Only add an access token to whitelisted origins

    const allowedOrigins = [environment.allowedOrigins];
       const accessToken = this.oktaAuth.getAccessToken();
        request = request.clone({
          setHeaders: {
            Authorization: 'Bearer ' + accessToken
          }
        });
    return next.handle(request).pipe( tap({
      error: err => {
        if (err instanceof HttpErrorResponse){
          if (err.status === 401){
            //this.router.navigate(['login']);
          }
          if (err.status === 404){
            //this.router.navigate(['page-not-found']);
          }
          //return;
        }
      }
    })).toPromise();
  }
}
